import ConsultasSolicitadas from "../ConsultasSolicitadas/ConsultasSolicitadas";
import { ConsultasSolicitadasData } from "../../../../global/utils/ConsultasSolicitadasData";
import Buscador from "../BuscadorEstudio/BuscadorEstudio";
import "./BuscadorUniversal.css";

const BuscadorUniversal = () => {
  return (
    <>
      <Buscador />
      <ConsultasSolicitadas items={ConsultasSolicitadasData} />
    </>
  );
};
export default BuscadorUniversal;
